import { vscodeDark } from '@uiw/codemirror-theme-vscode';
import {
  defaultSettingsDarcula,
  darculaInit,
} from '@uiw/codemirror-theme-darcula';
import { dracula } from '@uiw/codemirror-theme-dracula';
import {
  eclipseInit,
  defaultSettingsEclipse,
} from '@uiw/codemirror-theme-eclipse';
import {
  defaultSettingsGruvboxLight,
  gruvboxLightInit,
  defaultSettingsGruvboxDark,
  gruvboxDarkInit,
} from '@uiw/codemirror-theme-gruvbox-dark';

export const THEME = {
  FULLSCREEN: 'FULLSCREEN',
  VSCODE_THEME: 'VSCODE_THEME',
  DARCULA: 'DARCULA',
  DRACULA: 'DRACULA',
  GRUVBOX_DARK: 'GRUVBOX_DARK',
  GRUVBOX_LIGHT: 'GRUVBOX_LIGHT',
  ECLIPSE: 'ECLIPSE',
};

export const isLightTheme = (theme) => {
    switch (theme) {
      case THEME.GRUVBOX_LIGHT:
      case THEME.ECLIPSE:
        return true;
      default:
        return false;
    }
  };

export const getTheme = (theme) => {
  switch (theme) {
    case THEME.VSCODE_THEME:
      return vscodeDark;
    case THEME.DARCULA:
      return darculaInit({
        settings: {
          ...defaultSettingsDarcula,
          selection: 'rgba(255, 255, 255, 0.2)',
        },
      });
    case THEME.DRACULA:
      return dracula;
    case THEME.ECLIPSE:
      return eclipseInit({
        settings: {
          ...defaultSettingsEclipse,
          lineHighlight: '#e8f2ff7a',
          selection: '#afcdf3c7',
          caret: 'black',
        },
      });
    case THEME.GRUVBOX_DARK:
      return gruvboxDarkInit({
        settings: {
          ...defaultSettingsGruvboxDark,
          lineHighlight: '#3c3836b3',
        },
      });
    case THEME.GRUVBOX_LIGHT:
      return gruvboxLightInit({
        settings: {
          ...defaultSettingsGruvboxLight,
          lineHighlight: '#ebdbb24d',
        },
      });
    default:
      return vscodeDark;
  }
};
